import { lazyRoute } from "@/routes/lazy-route";

const ActivityLogPage = lazyRoute(() => import("./activity-log.page"), "ActivityLogPage");

export const activityLogRoutes = [
  {
    path: "activity-log",
    element: <ActivityLogPage />,
  },
];

